import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { EnvironmentProvider } from 'src/app/providers/environment.provider';
import { DeploymentSummaryComponent } from './deployment-tabs/deployment-summary/deployment-summary.component';
import { DeploymentConnectivityComponent } from './deployment-tabs/deployment-connectivity/deployment-connectivity.component';
import { DeploymentDataHealthComponent } from './deployment-tabs/deployment-data-health/deployment-data-health.component';
import { DeploymentNamcShopComponent } from './deployment-tabs/deployment-namc-shop/deployment-namc-shop.component';

@Component({
  selector: 'app-reporting-deployment',
  standalone: true,
  imports: [
    CommonModule,
    DeploymentSummaryComponent,
    DeploymentConnectivityComponent,
    DeploymentDataHealthComponent,
    DeploymentNamcShopComponent
  ],
  templateUrl: './reporting-deployment.component.html',
  styleUrl: './reporting-deployment.component.scss'
})
export class ReportingDeploymentComponent {

  activeProgramPage: 'summary' | 'connectivity' | 'dataHealth' | 'namcShopDetail' = 'summary';

  /** On production and qa only Deployment Summary and Connectivity are exposed. */
  readonly showRestrictedTabs: boolean;

  constructor(environmentProvider: EnvironmentProvider) {
    const envName = environmentProvider.environment?.envName;
    this.showRestrictedTabs = envName !== 'prod' && envName !== 'qa';
  }

  selectProgramPage(page: 'summary' | 'connectivity' | 'dataHealth' | 'namcShopDetail'): void {
    if (!this.showRestrictedTabs && (page === 'dataHealth' || page === 'namcShopDetail')) {
      return;
    }
    this.activeProgramPage = page;
  }
}
